import httpService from '@/core/http-service'

function login(payload) {
  return httpService.postAuth({
    username: payload.username,
    password: payload.password,
    grant_type: 'password'
  })
}

export default { login }
